import React from 'react';
import { CSVReader } from 'react-papaparse';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

function AcumaticaApplyPaymentsForm(props) {

    return (
        <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} display = "flex" flexDirection = "column">
            <Stack direction = "column" spacing = {2} sx = {{ mt: 2 }}>
                <Button 
                    variant = 'outlined'
                    onClick = {() => props.downloadTemplate()}
                    style = {{ width: '200px' }}
                >
                    Download Template
                </Button>
                <CSVReader
                    ref = {props.buttonRef}
                    onFileLoad = {props.handleOnFileLoad}
                    onError = {props.handleOnError}
                    noClick
                    noDrag
                    config = {{
                        header: true,
                        skipEmptyLines: true
                    }}
                    style = {{ marginTop: "20px", marginBottom: "20px" }}
                >
                {({ file }) => (
                    <aside style = {{marginTop: "20px", marginBottom: "20px"}}>
                        <Stack direction = "row" spacing = {2} sx = {{alignItems: 'center', mt: 2}}>
                            <Button 
                                variant = 'contained' 
                                onClick = {props.handleOpenDialog} 
                                className = {`${props.company} ${props.warehouse} secondary`}
                                disabled = {props.loading}
                            >
                                Browse file
                            </Button>
                            <div>
                                {props.file ? file.name : null}
                            </div>
                        </Stack>
                        {props.file !== null ? 
                            <Box>
                                <Button 
                                    variant = 'contained' 
                                    sx = {{ mt: '10px' }} 
                                    onClick = {props.uploadFile} 
                                    className = {`${props.company} ${props.warehouse} secondary`}
                                    disabled = {props.loading}
                                >
                                    Upload
                                </Button>
                                <Button 
                                    variant = 'contained' 
                                    sx = {{ mt: '10px', ml: '10px' }} 
                                    onClick = {props.handleRemoveFile} 
                                    className = {`${props.company} ${props.warehouse} tertiary`}
                                    disabled = {props.loading}
                                >
                                    Remove
                                </Button>
                            </Box>
                        : null}
                    </aside>
                )}
            </CSVReader>
        </Stack>
      </Box>
    );
  };

export default AcumaticaApplyPaymentsForm;